import React from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import CheckBox from "../CheckBox";
import type { PortfolioItemProps } from "./types";
import Translations from "@translate/components/PortfolioContainer/PortfolioItem";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export const PortfolioItem: React.FC<PortfolioItemProps> = ({
  item,
  mode = "select",
  onClick,
  onLockedClick,
  className,
}) => {
  const { label, isFull = false, isLocked = false, isChecked = false } = item;

  const handleClick = () => {
    // 如果是锁定状态，触发 onLockedClick
    if (isLocked && onLockedClick) {
      onLockedClick();
      return;
    }

    // 否则正常处理点击
    if (onClick) {
      if (mode === "select") {
        onClick(item);
      } else if (mode === "checkbox") {
        onClick(item, !isChecked);
      }
    }
  };

  const ItemContent = () => (
    <>
      {isLocked && (
        <div className="backdrop-blur-[13.333px] bg-background_brand_overlay20 relative rounded-66 shrink-0 w-4 h-4 flex flex-center text-content_brand_primary">
          <Icon name="lock-alt" size={10} />
        </div>
      )}
      <div className="flex gap-1 min-w-0 flex-1">
        <div
          className={cn(
            "body_medium_m text-content_primary whitespace-nowrap overflow-hidden text-ellipsis min-w-0",
            {
              "text-content_quaternary": isFull && mode !== "select",
            },
          )}
        >
          {label}
        </div>
        {isFull && (
          <div className="text-content_tertiary whitespace-nowrap py-0.5 px-1 rounded bg-background_white_overlay5 body_bold_xs flex flex-center">
            <span>{I18n.t("Reach Max.")}</span>
          </div>
        )}
      </div>
      {mode === "select" && isChecked && (
        <div className="ml-auto text-content_brand_primary flex">
          <Icon name="check" size={20} />
        </div>
      )}
      {mode === "checkbox" && (
        <div className="ml-auto">
          <CheckBox
            checked={isChecked}
            disabled={isLocked || (isFull && !isChecked)}
          />
        </div>
      )}
    </>
  );

  const baseClasses = cn(
    "flex h-10 items-center overflow-hidden px-2 py-2 relative shrink-0 w-full",
    isLocked ? "gap-1" : "gap-2",
    "cursor-pointer",
    className,
    !isFull && "hover:bg-background_white_overlay5 hover:rounded-[6px]",
  );

  return (
    <button
      aria-label="Item Content"
      data-openreplay-label="Item Content Button"
      id="btn-item-content"
      className={cn(baseClasses)}
      onClick={handleClick}
      disabled={isFull && !isChecked && mode !== "select"}
    >
      <ItemContent />
    </button>
  );
};
